const formatParams = (params: string) => {
  return params.trim().split(/\s+/);
};

export default formatParams;
